module.exports = __webpack_public_path__ + "img/thumbnail_Monarch_u_normal.ed337206.png";